var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "java",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E7D9D",
    d: "M4.44 22.324c9.472 1.553 17.265-.7 14.808-1.82 0 0 .671.559-.738.991-2.681.822-11.16 1.069-13.514.033-.846-.373.742-.89 1.24-.998.521-.114.819-.093.819-.093-.944-.671-6.089 1.317-2.615 1.887z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E7D9D",
    d: "M20.75 21.726s-.299.775-3.532 1.391c-3.646.694-8.146.613-10.813.168 0-.001.547.457 3.355.639 4.273.277 10.835-.153 10.99-2.198zm-5.555-5.177c-2.746.535-4.332.517-6.341.308-1.552-.163-.536-.924-.536-.924-4.019 1.348 2.237 2.879 7.852 1.218-.596-.213-.975-.602-.975-.602zm1.863 1.035c-.02.056-.089.117-.089.118 5.946-1.581 3.76-5.573.917-4.562-.25.09-.381.297-.381.297s.158-.064.509-.138c1.438-.304 3.496 1.945-.956 4.285z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2941B",
    d: "M9.243 7.627c-1.106 1.681.544 3.486 2.792 5.539-.877-2.004-3.851-3.759.001-6.836C16.84 2.494 14.374 0 14.374 0c.996 3.962-3.506 5.158-5.131 7.627z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2941B",
    d: "M17.347 4.902c0-.001-8.123 2.051-4.243 6.573 1.145 1.333-.301 2.533-.301 2.533s2.906-1.518 1.571-3.418c-1.247-1.772-2.203-2.652 2.973-5.688z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E7D9D",
    d: "M8.887 18.56c-3.648 1.031 2.219 3.162 6.865 1.149-.76-.3-1.306-.646-1.306-.646-2.071.398-3.032.429-4.913.211-1.553-.18-.646-.714-.646-.714zm7.105-3.89c.456-.315 1.086-.587 1.086-.587s-1.792.325-3.577.477c-2.184.185-4.529.221-5.705.062-2.786-.376 1.527-1.412 1.527-1.412s-1.675-.114-3.733.892c-2.437 1.191 6.024 1.733 10.402.568z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.7260e5c01c9b98bc16ec9387ba9f2ea4.svg";
export { ForwardRef as ReactComponent };